import React from 'react'

const Divider = () => {
  return (
    <>
      <hr className="my-1 h-0.5 border-t-0 bg-gray-100" />
      {/* <hr
        className="my-2 h-0.5 border-t-0"
        style={{
          background: "linear-gradient(90deg, rgba(149, 131, 198, 0) 1.46%, rgba(149, 131, 198, 0.6) 40.83%, rgba(149, 131, 198, 0.3) 65.57%, rgba(149, 131, 198, 0) 107.92%)"
        }}
      /> */}
    </>
  )
}

export default Divider
